export class AuditTrailFilterCriteria {
  action: string;
  companyUniqid: string;
  dateFrom: string;
  dateTo: string;

  constructor(userChoicesActiveFilters) {
    this.action = userChoicesActiveFilters.action;
    this.companyUniqid = userChoicesActiveFilters.companyUniqid;
    this.dateFrom = userChoicesActiveFilters.dateFrom;
    this.dateTo = userChoicesActiveFilters.dateTo;
  }
}
